module.exports = __webpack_public_path__ + "img/4.336a5366.png";